import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const assignGroups = async ({
	id,
	groupIds
}: {
	id: string;
	groupIds: number[];
}) => {
	const response = await cmsClient.post<unknown>(
		`/homepage/admin/store/user/${id}/groups/`,
		{ group_ids: groupIds }
	);

	return response.data;
};

const useAssignGroups = () => {
	const queryClient = useQueryClient();

	const onSuccess = (
		_: unknown,
		variables: { id: string; groupIds: number[] }
	) => {
		toast.success(<CustomToast type="Success" message="Groups assigned" />, {
			hideProgressBar: true
		});

		queryClient.invalidateQueries(["person-profile", variables.id]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(assignGroups, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useAssignGroups;
